function getLinkSlug({ id, slug }: { id: string; slug: string }): string {
  return `${id}-${slug}`;
}

export { getLinkSlug };
